import { useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as ExportCSV } from '../../assets/icons/export-csv.svg';
import { ReactComponent as ExportPdf } from '../../assets/icons/export-pdf.svg';
import { ReactComponent as Export } from '../../assets/icons/export.svg';

interface ExportButtonProperties {
  label: string;
  disableHoverEffect?: boolean;
  buttonList: { key: string; onClickFunction: () => void; allow: boolean }[];
  disabled?: boolean;
  loader?: boolean;
  version?: string;
  hoverLabel?: string;
}

/**
 * My Button function component
 */
function ExportButton({
  label,
  buttonList,
  disableHoverEffect,
  disabled,
  loader,
  version,
  hoverLabel,
}: ExportButtonProperties) {
  const reference = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [style, setStyle] = useState<any>({});
  /**
   * Click the outside page function
   */
  const handleClickOutside = (event: React.MouseEvent) => {
    if (reference.current === event.target) {
      setOpen(false);
    }
  };

  /**
   * View the export buttons
   * @param event
   */
  const viewButtons = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true);

    let rect: DOMRect | undefined;
    const target = event.target as HTMLElement;

    if (target.classList.contains('back-button')) {
      rect = target.getBoundingClientRect();
    } else {
      const closestButton = target.closest('.back-button') as HTMLButtonElement | null;
      if (!closestButton) {
        console.warn('Export button not found.');
        return; // Prevent error by exiting early
      }
      rect = closestButton.getBoundingClientRect();
    }

    if (rect) {
      setStyle({
        top: rect.top,
        left: rect.left + rect.width + 15,
      });
    }
  };

  return (
    <div className="export-button-wrap">
      <button
        type="button"
        className={`back-button back-button-${version} ${disableHoverEffect ? '' : 'on-hover'}`}
        onClick={viewButtons}
        disabled={disabled}>
        <span className="icon">
          <Export style={{ marginTop: '5px', width: '21px', height: '21px' }} />{' '}
        </span>
        {label && <span>{label}</span>}
      </button>
      {hoverLabel && <div className="hover-label">{hoverLabel}</div>}
      {open &&
        ReactDOM.createPortal(
          <div
            className={`export-buttons-container-${version}`}
            onClick={handleClickOutside}
            role="presentation"
            ref={reference}>
            <div className="export-buttons-list" style={style}>
              {!loader &&
                buttonList.map(
                  (button) =>
                    button.allow && (
                      <div
                        className="export-button-item"
                        onClick={button.onClickFunction}
                        key={button.key}
                        role="presentation">
                        {button.key === 'csv' ? <ExportCSV /> : <ExportPdf />}
                      </div>
                    ),
                )}
              {loader && (
                <div className="progress-bar">
                  <span className="bar">
                    <span className="progress" />
                  </span>
                </div>
              )}
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}

ExportButton.defaultProps = {
  disabled: false,
  disableHoverEffect: false,
  loader: false,
  version: 'v1',
  hoverLabel: '',
};

export default ExportButton;
